import PropTypes from 'prop-types';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import AddFundErrorMessage from './error-messages';
import style from './style.module.less';

const AddFundsErrorSection = ({ errors, currencyCode }) => {
  return (
    <div className={style['error-banner']}>
      <BannerMessageV2
        className={style['error-message']}
        content={
          <ul>
            {errors?.map((error, index) => {
              return <AddFundErrorMessage key={index} currencyCode={currencyCode} error={error} />;
            })}
          </ul>
        }
        status={BannerStatus.Error}
      />
    </div>
  );
};

AddFundsErrorSection.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object).isRequired,
  currencyCode: PropTypes.string.isRequired,
};

export default AddFundsErrorSection;
